var map = {
	"../admin/fiureport/fiureport.module": [
		"./src/app/admin/fiureport/fiureport.module.ts",
		"common"
	],
	"../admin/transaction/transaction.module": [
		"./src/app/admin/transaction/transaction.module.ts",
		"common"
	],
	"../admin/user/user.module": [
		"./src/app/admin/user/user.module.ts",
		"common"
	],
	"../agent/user/user.module": [
		"./src/app/agent/user/user.module.ts",
		"common"
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"./agent/agent.module": [
		"./src/app/agent/agent.module.ts",
		"common",
		"agent.module"
	],
	"./customer/customer.module": [
		"./src/app/admin/customer/customer.module.ts",
		"common"
	],
	"./fxrate/fxrate.module": [
		"./src/app/admin/fxrate/fxrate.module.ts",
		"common"
	],
	"./mobile/version/version.module": [
		"./src/app/admin/mobile/version/version.module.ts",
		"common"
	],
	"./notice/notice/notice.module": [
		"./src/app/admin/notice/notice/notice.module.ts",
		"common"
	],
	"./notice/push/push.module": [
		"./src/app/admin/notice/push/push.module.ts",
		"common"
	],
	"./report/report.module": [
		"./src/app/admin/report/report.module.ts",
		"common"
	],
	"./servicecharge/servicecharge.module": [
		"./src/app/admin/servicecharge/servicecharge.module.ts",
		"common"
	],
	"./transaction/transaction.module": [
		"./src/app/agent/transaction/transaction.module.ts",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main